module.exports = __webpack_public_path__ + "static/img_4560-4abd441e4a1fa9e35a559ea3e2fa94b5.webp";